module.exports = __webpack_public_path__ + "img/proList2_08_02.91c80adf.jpg";